import React, { useEffect, useState } from 'react';
import uniqueId from '../utilities/unique-id';

const SelectInput = ({
    i18n,
    required = false,
    text,
    value,
    name,
    autoComplete = 'off',
    autoFocus = false,
    options = [],
    onChange = null,
}) => {
    const id = uniqueId()
    const label = text || i18n[name]
    const defaultValue = value || '';

    const [formValue, setValue] = useState(defaultValue)

    if (!options.length) {
        return null;
    }

    const changed = event => {
        setValue(event.target.value)

        if (onChange) {
            onChange(event.target.value)
        }
    }

    useEffect(() => {
        setValue('')
    }, [value])

    return <div className="js-form-label small-label">
        <div className="relative">
            <label htmlFor={ id }>
                { label } { required ? <span style={{ color: '#C90600' }}>*</span> : null }
            </label>

            <select
                required={ required }
                className="styled-input"
                id={ id }
                name={ name }
                autoComplete={ autoComplete }
                autoFocus={ autoFocus }
                onChange={ changed }
                value={ formValue }
            >
                { !value ? <option disabled value="">{ i18n.please_select }</option> : null }
                { options.map(option => {
                    return <option key={option.key || option.value} value={option.value}>{ option.label }</option>
                })}
            </select>

            { required && options.length && <input type="hidden" name={ `${name}_required` } value={'1'} /> }
        </div>
    </div>

}

export default SelectInput;
